import { ElementRef, Injectable } from '@angular/core';
import { mapStylesMC } from './models';

@Injectable({
    providedIn: 'root',
})
export class IqMcMapLoaderService {
    constructor() {}

    async loadMap(_mapRef: ElementRef<any>): Promise<google.maps.Map> {
        const map = new google.maps.Map(
            _mapRef.nativeElement.querySelector('[data-uitype="map"]'),
            {
                center: { lat: 44, lng: -98 },
                zoom: 4,
                minZoom: 3,
                disableDefaultUI: true,
                zoomControl: true,
                styles: mapStylesMC,
                fullscreenControl: true,
                controlSize: 24,
                scrollwheel: false,
                fullscreenControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_TOP,
                    
                },
                zoomControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_TOP,
                }
            },
        );

        return map;
    }
}
